<script lang="ts">
	import { Background } from "@components/Background.js";
	import Section from "@components/Section.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import type { PrivacyPolicyProps } from "./PrivacyPolicyProps.js";

	const _: PrivacyPolicyProps = $props();
</script>

<Layout>
	<Section
		paddingFollowNext
		background={Background.LightGradient}
		centered
		gridHeadline="container-6"
		gridDesc="container-6"
		hero
	>
		{#snippet headline()}
			<Formatted text="Ochrana osobních údajů" />
		{/snippet}
	</Section>

	<Section gridChildren="container-start-2 container-end-8 article" noPadding="top">
		<h2>
			<Formatted text="Sesbírané informace a jejich využití" />
		</h2>
		<p>
			<Formatted
				text="Využití webu a formuláře na webu www.fastest.cz může být ze strany Provozovatele podmíněn poskytnutím některých osobních údajů Uživatele ve smyslu zák. č. 110/2019 Sb., o ochraně osobních údajů a případně i jiných zákonů, v platném znění. V takovém případě bude Provozovatel s těmito údaji nakládat v souladu s platnými právními předpisy."
			/>
		</p>
		<h2>
			<Formatted text="Předávání osobních údajů" />
		</h2>
		<p>
			<Formatted
				text="Provozovatel spolupracuje se společnostmi, které mu poskytují různé služby. Tyto společnosti, pokud jsou k tomu oprávněné, mohou nakládat s osobními údaji Uživatele, přičemž s těmito informacemi pracují pouze při plnění svých povinností a nesmí je použít k jinému účelu. Provozovatel neprodává, nepřevádí a nesděluje osobní údaje třetím stranám."
			/>
		</p>
		<p>
			<Formatted
				text="Provozovatel si však vyhrazuje právo použít nebo předat jakýkoli údaj, který bude potřebný k naplnění právních předpisů, k ochraně integrity sítě, ke splnění požadavku Uživatele nebo při soudním vyšetřování a vyšetřování ve veřejném zájmu."
			/>
		</p>
		<p>
			<Formatted
				text="Pokud si Uživatel přeje opravit osobní data, které o něm Provozovatel má, může jej o to požádat na emailové adrese info@fastest.cz nebo na poštovní adrese uvedené na stránce Kontakty."
			/>
		</p>
		<h2>
			<Formatted text="Kódy třetích stran" />
		</h2>
		<p>
			<Formatted
				text="Na tomto webu používáme kódy od společnosti Google, které nám pomáhají analyzovat chování návštěvníků webu."
			/>
		</p>
		<h2>
			<Formatted text="Google Analytics" />
		</h2>
		<p>
			<Formatted
				text="Tyto stránky využívají službu Google Analytics, poskytovanou společností Google, Inc. (dále jen „Google“). Služba Google Analytics používá souborů „cookies“, které jsou textovými soubory ukládanými do vašeho počítače, umožňující analýzu způsobu užívání této stránky jejími uživateli. Informace vygenerované souborem cookie o užívání stránky (včetně vaší IP adresy) budou společností Google přeneseny a uloženy na serverech ve Spojených státech."
			/>
		</p>
		<p>
			<Formatted
				text="Google bude užívat tyto informace pro účely vyhododnocování užívání stránky a vytváření zpráv o její aktivitě, určených pro její provozovatele, a pro poskytování dalších služeb týkajících se činností na stránce a užívání internetu vůbec. Google může také poskytnout tyto informace třetím osobám, bude-li to požadováno zákonem nebo budou-li takovéto třetí osoby zpracovávat tyto informace pro Google. Google nebude spojovat vaši IP adresu s jakýmikoli jinými daty, která má k dispozici. Můžete odmítnout používání souborů cookies volbou v příslušném nastavení ve vašem prohlížeči, avšak uvědomte si, že jestliže tak učiníte, nebudete schopni plně využívat veškeré funkce této stránky. Používáním této stránky souhlasíte se zpracováváním údajů o vás společností Google, a to způsobem a k účelu shora uvedeným."
			/>
		</p>
		<p>
			<Formatted
				text="Detailní informace o Google Analytics a ochraně osobních údajů naleznete na [policies.google.com][[policies.google.com/privacy]]."
			/>
		</p>
		<h2>
			<Formatted text="Cookies" />
		</h2>
		<p>
			<Formatted
				text="„Cookies“ jsou informace, které jsou z internetové stránky převáděny na hard disk počítače Uživatele. Cookies umožňují internetové stránce zapamatovat si důležité informace, které Uživateli ulehčí další její používání. Jako většina internetových stránek, i stránky Provozovatele používají cookies. Na základě anonymních datových objektů například Provozovatel sleduje celkový počet návštěvníků na těchto stránkách. Pokud nechce Uživatel cookies používat nebo pokud chce, aby internetový prohlížeč použití cookies oznámil, musí tento ve svém internetovém prohlížeči vybrat příslušnou volbu. Zablokuje-li Uživatel všechna cookies, nebude moci využít některé funkce těchto stránek."
			/>
		</p>
		<h2>
			<Formatted text="Změny v politice ochrany osobních dat" />
		</h2>
		<p>
			<Formatted
				text="Provozovatel si vyhrazuje právo jakkoliv a kdykoliv měnit svoji politiku ochrany osobních dat, přičemž aktuální stav bude vždy umístněn na těchto stránkách."
			/>
		</p>
		<h2>
			<Formatted text="Chování uživatelů" />
		</h2>
		<p>
			<Formatted
				text="Při používání těchto stránek Uživatel nesmí zasahovat do bezpečnosti těchto stránek, nemůže tyto stránky využívat k přenášení škodlivých souborů a snažit se proniknout do veřejně nepřístupných míst těchto stránek. Uživatel je rovněž povinen ctít autorská práva Provozovatele k těmto stránkám."
			/>
		</p>
		<h2>
			<Formatted text="Odpovědnost a právní příslušnost" />
		</h2>
		<p>
			<Formatted
				text="Případná rizika plynoucí Uživateli z používání těchto stránek, jsou zcela na Uživateli a Provozovatel za ně nenese jakoukoliv odpovědnost. Veškeré spory vzniklé v souvislosti s využíváním těchto stránek, budou projednávány místně příslušným soudem v České republice a v souladu se zákony České republiky. Ustanovení těchto podmínek, které se z jakéhokoliv důvodu stanou nevymahatelné, budou považována za oddělitelná od zbývajících ujednání a na jejich platnost a vymahatelnost nebudou mít vliv. Veškeré údaje, uvedené na těchto stránkách včetně použitého obrazového materiálu mají nezávazný informativní charakter a tyto nelze vykládat jako nabídku na uzavření smlouvy, ani jako vymahatelné smluvní podmínky. Závazné informace budou klientovi předloženy vždy v rámci konkrétní obchodní a smluvní dokumentace."
			/>
		</p>
	</Section>
</Layout>
